// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"badda734","664":"a33eac60"}[chunkId] + ".chunk.js";
};